export const socialLinks = [
  { href: "https://www.facebook.com/p/SB-Tech-AS-100088234314196/", iconClass: "feather-facebook" },
  { href: "https://www.linkdin.com/", iconClass: "feather-linkedin" },
];

export const socialLinksWithSal = [
  {
    href: "https://www.facebook.com/",
    iconClass: "feather-facebook",
    salDelay: 200,
  },
  {
    href: "https://www.twitter.com",
    iconClass: "feather-twitter",
    salDelay: 300,
  },
  {
    href: "https://www.instagram.com/",
    iconClass: "feather-instagram",
    salDelay: 400,
  },
  {
    href: "https://www.linkdin.com/",
    iconClass: "feather-linkedin",
    salDelay: 500,
  },
];

export const footerSections = [
  {
    title: "Produkter",
    links: [
      { href: "/company/product/drill", label: "Boretårn" },
      { href: "/company/product/boring", label: "Borerigger" },
      { href: "/company/product/addon", label: "Påbyggere" },
    ],
  },
  {
    title: "Tjenester",
    links: [
      { href: "/company/service/process", label: "Prosess" },
      { href: "/company/service/agro", label: "Landbruk" },
      { href: "/company/service/special", label: "Spesial" },
    ],
  },
  {
    title: "Projekter",
    links: [
      { href: "/company/projects", label: "Alle prosjekter" },
    ],
  },
  {
    title: "Selskapet",
    links: [
      { href: "/company/company/team", label: "Ansatte" },
      { href: "/company/company/about", label: "Om oss" }, 
      { href: "/company/company/contact", label: "Kontakt" }, 
    ],
  },
];
